export default [
  {
    component: 'CNavItem',
    name: 'Clientes',
    to: '/clientes',
    icon: 'cil-file',
    badge: {
      color: 'primary',
    },
  },
]
